import { Input } from '@mobiscroll/react-latest'
import * as classNames from 'classnames'
import * as React from 'react'

interface ITextField {
  error?: string
  title: string
  isOptional?: boolean
  placeholder: string
  onChange: (e: any) => any
  handleBlur: (e: any) => any
  name: string
  value: string
}

const TextField = (props: ITextField) => {
  const inputStyle = classNames('col-12 rounded p1', {
    'border-light-grey4': !props.error,
    'border-red': !!props.error
  })
  return (
    <div>
      <Input
        label={props.placeholder}
        type='text'
        className='mobiscroll-input form'
        onChange={props.onChange}
        onBlur={props.handleBlur}
        name={props.name}
        value={props.value}
        theme='ios'
        themeVariant='light'
        inputStyle='box'
        labelStyle='floating'
      />
    </div>
  )
}

export default TextField



// WEBPACK FOOTER //
// ./src/components/drivers/TextField.tsx